import React from "react";
import moment from "moment/moment";
import Pagination from "../utils/Pagination";
import {
  handleItemsPerPageChange,
  handlePageChange,
} from "../utils/PaginationUtilities";
import { Link } from "react-router-dom";
import { API_URL } from "../config/ApiServices";
import IconButton from "@mui/material/IconButton";
import AttachmentIcon from "@mui/icons-material/Attachment";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "../redux/actions/ModalActions";

export default function Material({
  material,
  totalData,
  currentPage,
  itemsPerPage,
}) {
  const getDate = (date) => moment(date).format("Do MMM YY HH:MM");
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.modal.isOpen);

  const getAttachmentName = (filename) => {
    if (!filename) return "";
    let parts = filename.split("/");
    let actutalName = parts.slice(4).join("/");
    return actutalName;
  };

  return (
    <div className="container">
      <div className="row">
        <div className="accordion" id="accordionExample">
          <div className="col-sm-12 text-capitalize d-flex justify-content-end">
            <button
              onClick={() => {
                dispatch(showModal("AddMaterial"));
              }}
              className="btn btn-primary btn-round"
            >
              Add Material
            </button>
          </div>
          <div className="col-sm-12 text-capitalize">
            {material?.length > 0 ? (
              material?.map((el, index) => (
                <div className="accordion-item my-2" key={index}>
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button d-flex justify-content-between"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${index}`}
                      aria-expanded={el.isactive}
                    >
                      <div>{el.title}</div>
                      <div className="text-muted d-flex align-items-center fs-6">
                        <span className="me-3">
                          Posted By: {el?.trainerId?.name || "Unknown"}
                        </span>
                        <span>
                          Posted {getDate(el?.PostedAt || el?.createdAt)}
                        </span>
                      </div>
                    </button>
                  </h2>
                  <div
                    id={`collapse${index}`}
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="d-flex justify-content-between">
                        <div>{el?.description}</div>
                        <div className="attachments">
                          {el.attachments?.map((file, idx) => (
                            <div
                              key={idx}
                              className="d-flex align-items-center"
                            >
                              <Link
                                to={`${file}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <AttachmentIcon sx={{ ml: 1, color: "grey" }} />
                                <span className="ms-2">
                                  {getAttachmentName(file)}
                                </span>
                              </Link>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
            //   <h1>No Material Present!!</h1>
            <div className="text-capitalize">

                <div className="accordion-item">No Material Present!!</div>
            </div>
            )}
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <Pagination
          count={totalData}
          page={currentPage}
          itemsPerPage={itemsPerPage}
          onPageChange={handlePageChange}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      </div>
    </div>
  );
}
